import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Image, Spinner } from 'react-bootstrap';
import creationIC from '../../../assets/images/creation-ic.svg';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import { useAuth } from '../../auth/Auth';
import { notificationViewModel } from './notification.view.model';
import ReactTimeAgo from 'react-time-ago';
import InfiniteScroll from 'react-infinite-scroller';
import { useHistory } from 'react-router-dom';
import { HOME_FEED, SHARE_CREATION_ROUTE_BANNER } from '../../../constants/routes.constants';
import EmptyImg from '../../../assets/images/empty-noti.png';
import { getCommentUserProfileUrl, getUserProfileUrl } from '../../../utils/camp.utils';
import binkyCommentIcon from '../../../assets/icon/Compliment.svg';

const Notification = () => {
    const _PAGE_LIMIT = 5;
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const { dependent, guardian, fetchAPI } = useAuth();
    const [notification, setNotification] = useState([]);
    let current_date = new Date();
    const [query, setQuery] = useState({
        limit: _PAGE_LIMIT,
        has_more: true,
    });

    const getNotificationList = () => {
        const previousFeedList = notification;
        fetchAPI(notificationViewModel.getNotifications, query, previousFeedList).then((res) => {
            setIsLoading(false)
            let d = new Date()
            d.setDate(d.getDate() - 5)
            ReactDOM.unstable_batchedUpdates(() => {
                setNotification(res.notificationList);
                setQuery(res.query)
            })
        }).catch((err) => console.log(err));
    }

    useEffect(() => {
        getNotificationList();
    }, [])

    const getFullDate = (date) => {
        let d = new Date(date)
        let tempDate = String(d.getDate()) + String(d.getMonth() + 1) + String(d.getFullYear())
        return (tempDate)
    }

    const returnDependentProfile = (user) => {
        const kid = {
            profile: {
                picture_url: user?.picture_url,
                taletree_friend: user?.taletree_friend
            }
        }
        return kid
    }

    return (
        <div>
            {dependent && !guardian ?
                <CampHeader /> : <CampHeaderGuest />
            }
            {!isLoading && notification.length === 0 ?
                <div className='notification-empty-box'>
                    <div className='choose-class notification-modal empty-class'>
                        <Image
                            className="profile-image"
                            src={EmptyImg}
                        />
                        <h3>You have no notifications yet!</h3>
                        <p>Don’t be sad, when you get notifications, they’ll show up here</p>
                        <button type="button" onClick={() => history.push(HOME_FEED)} className="common-round-btn m-auto button btn btn-primary gred-btn">Return home</button>
                    </div>
                </div>
                :
                <div className="notification-wrapper">
                    <div className="notification-wrapper-inner">
                        <div className="most-recent">
                            <h4>Chat with your companion</h4>
                            <ul>
                                <InfiniteScroll
                                    pageStart={0}
                                    loadMore={getNotificationList}
                                    hasMore={query.has_more}
                                    threshold={150}
                                    className="home-feed-spinner-wrapper"
                                    loader={
                                        <Spinner
                                            key={0}
                                            className="home-feed-spinner"
                                            animation="border"
                                            variant="info"
                                        />
                                    }
                                >
                                    {notification.map((data, key) => {
                                        return (
                                            <li key={key}>
                                                <div className="notiUsrdetailWrapper">
                                                    <div className="notiUsrImg" role='button'
                                                        onClick={() =>
                                                            data?.object_user?.user_type === 'dependent' && history.push(`/${data.object_user.username}`)
                                                        }>
                                                        {data?.object_user?.picture_url ?
                                                            <Image src={data?.object_user?.picture_url} alt="" />
                                                            : <Image src={data?.object_user?.user_type === 'dependent' ? getUserProfileUrl(returnDependentProfile(data?.object_user)) : getCommentUserProfileUrl(data?.object_user)} alt="" />
                                                        }
                                                    </div>
                                                    <div className="notiUsrdetails">
                                                        <h5 role='button'
                                                            onClick={() =>
                                                                data?.object_user?.user_type === 'dependent' && history.push(`/${data.object_user.username}`)
                                                            }>
                                                            {data?.object_user?.user_type === 'dependent' ? data?.object_user?.username : data?.object_user?.first_name + " " + data?.object_user?.last_name} {data?.object_user?.user_type !== 'dependent' && <button className="blue-admin-button">{data?.object_user?.user_type === 'school_teacher' ? "Captain" : data?.object_user?.user_type === "school" ? "Master" : data?.object_user?.user_type=== "camp master" ? "Expert" : "Partner"}</button>}
                                                        </h5>
                                                        <div className="your-creation">
                                                            {data?.from_object === 'comment' ?
                                                                <>
                                                                    <img src={binkyCommentIcon} style={{height: '25px'}} className={`binky-comment-icon`} />
                                                                    {/* <span className="creation-ic"><Image src={creationIC} alt="" /></span> */}
                                                                    <span>commented on your creation!</span>
                                                                </>
                                                                :
                                                                <>
                                                                    <span className="creation-ic"><Image src={creationIC} alt="" /></span>
                                                                    <span>Your creation!</span>
                                                                </>
                                                            }
                                                            <ReactTimeAgo date={data.created_at} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="noti-on-img" role='button' onClick={() =>
                                                    history.push({
                                                        pathname: SHARE_CREATION_ROUTE_BANNER,
                                                        search: `?encrypt=${btoa(`{"id":${data.from_creation.id}, "slug":"creation"}`)}`
                                                    })
                                                }>
                                                    <Image src={data.from_creation.media[0].url} alt="" />
                                                </div>
                                            </li>
                                        )
                                    })}
                                </InfiniteScroll>
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Notification;        
